import { useCallback, useState } from 'react';
import { useAxiosCmsInstance, useCmsExternalServiceQuery } from '@gov-nx/api';
import { GovError } from '@gov-nx/core/app';
import type { Nullable } from '@gov-nx/core/types';
import { useCmsStore, useCmsStoreExternalService } from '@gov-nx/store';
import { delay } from '@gov-nx/utils/common';

export interface CmsExternalServiceLoaderProps {
	onSuccess?: () => void;
	onError?: (e: Error) => void;
}

export const useCmsExternalServiceLoader = (
	props?: CmsExternalServiceLoaderProps
) => {
	const saveCmsExternalService = useCmsStore('saveCmsExternalService');
	const [id, setId] = useState<Nullable<number>>(null);
	const externalService = useCmsStoreExternalService(id);
	const { axiosCmsInstance } = useAxiosCmsInstance();

	const query = useCmsExternalServiceQuery(axiosCmsInstance, {
		id,
		onError: (message: string) => {
			props?.onError && props?.onError(new GovError(message));
		},
		onSuccess: (data) => {
			saveCmsExternalService(id as number, data);
			props?.onSuccess && props.onSuccess();
		},
	});

	const loadExternalService = useCallback(
		async (id: number): Promise<void> => {
			setId(id);
			await delay(200);
			await query.refetch();
		},
		[query]
	);

	return { loadExternalService, externalService };
};
